import Vuex from 'vuex';
import Vue from 'vue';

import ApiService from "../../../js/modules/ApiService";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        offices: [],
        office: [],
        cities: [],
        myMap: null,
    },
    mutations: {
        setCities: (state, cities) => {
            state.cities = cities;
        },
        setOffices: (state, offices) => {
            state.offices = offices;
        },
        setOffice: (state, office) => {
            state.office = office;
        }
    },
    actions: {
        initMap: ({state, dispatch}) => {
            state.myMap = new window.ymaps.Map("map", {
                center: [state.offices[0].latitude, state.offices[0].longitude],
                zoom: 4,
                controls: [],
            });

            dispatch('setPlacemarks');

            state.myMap.controls.add('zoomControl');
        },
        setPlacemarks: ({state, dispatch}) => {
            let placemarks = [];

            state.myMap.geoObjects.removeAll();

            state.offices.forEach((office) => {
                placemarks[office.id] = new window.ymaps.Placemark([office.latitude, office.longitude], {
                    balloonContent: office.branch_name,
                    balloonCloseButton: true,
                    hideIconOnBalloonOpen: false
                });

                placemarks[office.id].events.add('click', function () {
                    dispatch('getOfficeInfo', office.id);
                });

                state.myMap.geoObjects.add(placemarks[office.id]);
            });
        },
        citiesList: ({commit}) => {
            new ApiService().get('/all-cities')
                .then((response) => {
                    commit('setCities', response.data);
                });
        },
        cityOfficesList: ({commit, dispatch, state}, city) => {
            new ApiService().get('/city-offices/' + city)
                .then((response) => {
                    commit('setOffices', response.data);
                    if (state.myMap) {
                        dispatch('setPlacemarks');
                    }
                });
        },
        allOfficesList: ({commit, dispatch, state}) => {
            new ApiService().get('/all-offices')
                .then((response) => {
                    commit('setOffices', response.data);
                    dispatch('setPlacemarks');
                });
        },
        getOfficeInfo: ({commit}, office) => {
            new ApiService().get('/office/' + office)
                .then((response) => {
                    commit('setOffice', response.data);
                });
        },
    },
});

